// src/services/devIdentity.js
// Gives every browser TAB a stable fake identity when there's no Telegram
// session — i.e. when you're just testing in a normal browser.
// sessionStorage is per-tab, so opening two tabs in the same browser gives
// you two different "players" to test multiplayer with locally.

function randomId() {
  return 900000000 + Math.floor(Math.random() * 99999999);
}

export function getDevUserId() {
  if (window.Telegram?.WebApp?.initData) return null; // real Telegram session, not needed
  let id = sessionStorage.getItem("dev_user_id");
  if (!id) {
    id = String(randomId());
    sessionStorage.setItem("dev_user_id", id);
  }
  return id;
}
